module.exports = __webpack_public_path__ + "static/media/eyelab.48f0cd27.jpg";